interface SizeTable {
  headers: string[];
  body: { [key: string]: number[] };
}

const headers = ['身丈(cm)', '身幅(cm)', '肩幅(cm)', '袖丈(cm)']

export class ItemSpec {
  static sizeTable (itemName: string): SizeTable {
    switch (itemName) {
      case 't-shirt-united-athle-5001':
        return {
          headers,
          body: {
            S: [65, 49, 42, 19],
            M: [69, 52, 46, 20],
            L: [73, 55, 50, 22],
            XL: [77, 58, 54, 24]
          }
        }
      case 'long-sleeve-t-shirt-united-athle-5011':
        return {
          headers,
          body: {
            S: [65, 49, 42, 60],
            M: [69, 52, 45, 62],
            L: [73, 55, 45, 63],
            XL: [77, 58, 48, 64]
          }
        }
      case 'sweat-united-athle-5044':
        return {
          headers,
          body: {
            S: [63, 52, 44, 57],
            M: [67, 55, 48, 59],
            L: [71, 58, 52, 60],
            XL: [76, 63, 55, 61]
          }
        }
      default:
        return {
          headers: [],
          body: {}
        }
    }
  }
}
